import axios, { AxiosPromise } from 'axios';

export const FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS = 'FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS';
export const FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS_FULFILLED = `${FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS}_FULFILLED`;
export const FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS_REJECTED = `${FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS}_REJECTED`;

interface GetTemplateActionMeta {
  languageCode?: string;
  templateName: string;
  queryToFilter?: [string, string];
}

interface AxiosPromiseResponse {
  data: any;
}

interface GetTemplateAction {
  type: typeof FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS;
  payload: AxiosPromise<AxiosPromiseResponse>;
  meta: GetTemplateActionMeta;
}

export interface GetTemplateActionResponse {
  type: typeof FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS_FULFILLED | typeof FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS_REJECTED;
  payload: AxiosPromiseResponse;
  meta: GetTemplateActionMeta;
}

interface QueryParams {
  key: string;
  value: string;
}

export function getTemplateContentByQueryParams(
  templateName: string,
  queryToFilter?: QueryParams[],
  additionalHeaders?: any
): GetTemplateAction {
  let templateUrl = `${process.env.REACT_APP_CMS_TEMPLATE_CONTENT_SERVICE_ENDPOINT}/${templateName}`;

  if (queryToFilter && queryToFilter.length > 0) {
    queryToFilter.forEach((param: QueryParams) => {
      templateUrl += `?${param.key}=${param.value}`;
    });
  }
  return {
    type: FETCH_TEMPLATE_CONTENT_BY_QUERY_PARAMS,
    payload: axios.get(templateUrl, {
      headers: {
        ...additionalHeaders,
        'Customer-Facing-Tool': process.env.REACT_APP_CFT,
        CFT: process.env.REACT_APP_CFT,
        MSessionId: sessionStorage.getItem('sessionId')
      }
    }),
    meta: { templateName }
  };
}
